<template>
  <div class="flex flex-row justify-center gap-xs">
    <font-awesome-icon v-if="iconType" :icon="iconType" size="lg" />
    <LabelItem><slot></slot></LabelItem>
  </div>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTriangleExclamation,
  faUser,
  faUserGroup,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";

import LabelItem from "./LabelItem.vue";

const props = defineProps<{
  icon?: "varning" | "kund" | "ombud";
}>();

library.add(faUser, faUserGroup, faTriangleExclamation);

const iconType = computed(() => {
  switch (props.icon) {
    case "varning":
      return "fa-regular fa-triangle-exclamation";
    case "kund":
      return "fa-regular fa-user";
    case "ombud":
      return "fa-regular fa-user-group";
    default:
      return false;
  }
});
</script>
